import React, { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";

import PublicRoute from "./components/PublicRoute/PublicRoute";
import PrivateRoute from "components/ProtectedRoute/PrivateRoute";
import SupportPortalLayout from "pages/SupportPortal/BoxModal/SupportPortalLayout";
import { PATH } from "utils/pagePath";
import PreLogin from "layouts/PreLogin/PreLogin";


const LazyLogin = lazy(() => import("./pages/Login/Login"));
const LazyRegister = lazy(() => import("pages/Register/Register"));
const LazySetPassword = lazy(() => import("pages/SetPassword/SetPassword"));

const LazyPostLogin = lazy(() => import("./layouts/PostLogin/PostLogin"));
const LazyForgotPassword = lazy(() =>
    import("./pages/ForgotPassword/ForgotPassword")
);
const LazyOtpVerification = lazy(() =>
    import("./pages/OtpVerification/OtpVerification")
);
const LazyConfirmPassword = lazy(() =>
    import("./pages/ConfirmPassword/ConfirmPassword"));
const LazyInvitationNew = lazy(() => import("./pages/SetPassword/SetPassword"));



const LazySupportPortal = lazy(() =>
    import('pages/SupportPortal/SupportPortal'));

const LazyTechnicalSupportForm = lazy(() =>
    import('pages/SupportPortal/components/TechnicalSupportForm'));

const LazyCustomerRequests = lazy(() =>
    import('pages/SupportPortal/components/CustomerRequests'));

const LazyViewProfile = lazy(() => import("pages/Profile/ViewProfile"));


const LazyIssueDetails = lazy(() =>
    import('pages/SupportPortal/components/IssueDetails'));

const LazyCustomerServicceMenu = lazy(() =>
    import('pages/SupportPortal/components/CustomerServiceMenu'));

const routerSupport = [
    {
        path: PATH.DEFAULT,
        element: <Navigate to={PATH.LOGIN} replace />,
    },
    {
        element: (
            <PublicRoute component={<PreLogin />}>
                {/* <LazyPreLogin /> */}
            </PublicRoute>
        ),
        children: [
            {
                path: PATH.LOGIN,
                element: <LazyLogin />,
            },
            {
                path: PATH.FORGOT_PASSWORD,
                element: <LazyForgotPassword />,
            },
            {
                path: PATH.REGISTER,
                element: <LazyRegister />,
            },
            {
                path: PATH.OTP_VERIFICATION,
                element: <LazyOtpVerification />,
            },
            {
                path: PATH.CONFIRM_PASSWORD,
                element: <LazyConfirmPassword />,
            },
            // {
            //   path: PATH.INVITATION,
            //   element: <LazyInvitation />,
            // },
            {
                path: PATH.INVITATION,
                element: <LazyInvitationNew />,
            },
            {
                path: PATH.SET_PASSWORD,
                element: <LazySetPassword />,
            },
        ],
    },
    {
        element: (
            <PrivateRoute component={<LazyPostLogin />}>
                {/* <LazyPostLogin /> */}
            </PrivateRoute>
        ),
        children: [
            {
                path: PATH.SUPPORT_PORTAL,
                element: <SupportPortalLayout />,
                children: [
                    {
                        path: PATH.SUPPORT_PORTAL,
                        element: <LazySupportPortal />
                    },
                    {
                        path: `${PATH.SUPPORT_PORTAL}/customer-service-menu/:id`,
                        element: <LazyCustomerServicceMenu />
                    },
                    {
                        path: `${PATH.SUPPORT_PORTAL}/customer-service-menu/:id/request`,
                        element: <LazyTechnicalSupportForm />
                    },
                    {
                        path: `${PATH.SUPPORT_PORTAL}/customer/requests`,
                        element: <LazyCustomerRequests />
                    },
                    {
                        path: `${PATH.SUPPORT_PORTAL}/profile-viewprofile`,
                        element: <LazyViewProfile />
                    },
                    {
                        path: `${PATH.SUPPORT_PORTAL}/customer/requests/issue/:issueId`,
                        element: <LazyIssueDetails />
                    },
                ]

            }
        ]
    }
];

export default routerSupport
